module.exports = __webpack_public_path__ + "static/media/pt.7b7f66ee.webp";